export const ANALYTICS_SLICE_NAME = "disputesAnalytics"

// One key per block of data in the store. A card and its "View All" page share a key when they
// make the same request; where the page asks for something else (paging, search, its own chart
// controls) it gets a key of its own, so neither ever shows the other's rows.
export const ANALYTICS_SECTION = {
  KPIS: "kpis",
  TREND: "trend",
  QUEUE: "queue",
  FLOW: "flow",
  BY_CATEGORY: "byCategory",
  BY_COUNTRY: "byCountry",
  BY_CARD_NETWORK: "byCardNetwork",
  WIN_RATE_MATRIX: "winRateMatrix",
  REPEAT_DISPUTERS: "repeatDisputers",
  REPEAT_DISPUTERS_PAGE: "repeatDisputersPage",
  CATEGORY_TRENDS: "categoryTrends",
  REASON_CODES_TREND: "reasonCodesTrend",
  ACTIVITY: "activity",
  ACTIVITY_PAGE: "activityPage"
}
